import { RootState } from "app/store";
import { createSelector } from "@reduxjs/toolkit";

export const selectActivationPortalReducerLoading = (state: RootState) =>
  state.rootReducer.activationPortalReducer.loading;

export const selectActivationCodeLoading = (state: RootState) =>
  state.rootReducer.activationPortalReducer.verificationCodeLoading;

//  Activation Portal State Selectors

export const selectAllInstallations = (state: RootState) =>
  state.rootReducer.activationPortalReducer.installations;

export const selectAllSubscriptions = (state: RootState) =>
  state.rootReducer.activationPortalReducer.subscriptions;

export const selectAllInformationSecurityQuestions = (state: RootState) =>
  state.rootReducer.activationPortalReducer.securityQuestions;

export const selectAllSubscribeFormData = (state: RootState) =>
  state.rootReducer.activationPortalReducer.subscribeFormData;

export const selectVerificationCode = (state: RootState) =>
  state.rootReducer.activationPortalReducer.verificationCode;

export const selectMyAccounts = (state: RootState) =>
  state.rootReducer.activationPortalReducer.myAccounts;

export const selectFromDashboard = (state: RootState) =>
  state.rootReducer.activationPortalReducer.fromDashboard;

//  Payment Method Selectors

export const selectPaymentMethodsCatalog = (state: RootState) =>
  state.rootReducer.activationPortalReducer.methodsCatalog;

export const selectPaymentMethodsLoading = (state: RootState) =>
  state.rootReducer.activationPortalReducer.methodsCatalogLoading;

export const selectPaymentMethodsError = (state: RootState) =>
  state.rootReducer.activationPortalReducer.methodsCatalogError;

export const selectSelectedPaymentMethod = (state: RootState) =>
  state.rootReducer.activationPortalReducer.selectedPaymentMethod;

export const selectActivationPaymentState = createSelector(
  selectPaymentMethodsCatalog,
  selectPaymentMethodsLoading,
  selectPaymentMethodsError,
  selectSelectedPaymentMethod,
  (
    methodsCatalog,
    methodsCatalogLoading,
    methodsCatalogError,
    selectedPaymentMethod
  ) => ({
    methodsCatalog,
    methodsCatalogLoading,
    methodsCatalogError,
    selectedPaymentMethod
  })
);

export const selectActivationPortalState = createSelector(
  selectActivationPortalReducerLoading,
  selectAllInstallations,
  selectAllSubscriptions,
  selectAllInformationSecurityQuestions,
  selectAllSubscribeFormData,
  selectVerificationCode,
  selectMyAccounts,
  selectFromDashboard,
  selectActivationCodeLoading,
  (
    loading,
    installations,
    subscriptions,
    securityQuestions,
    subscribeFormData,
    verificationCode,
    myAccounts,
    fromDashboard,
    verificationCodeLoading
  ) => ({
    loading,
    installations,
    subscriptions,
    securityQuestions,
    subscribeFormData,
    verificationCode,
    myAccounts,
    fromDashboard,
    verificationCodeLoading
  })
);
